<template>
    <div class="yd-news-xiansuo" @click="newsClick(newsData.newsContentURL)">
        <p class="yd-title">{{newsData.newsContentTitle}}</p>
        <img v-if="newsData.newsContentImage" :src="newsData.newsContentImage" alt="请输入正确的图片地址">
        <el-form ref="form">
            <el-form-item>
                <el-input placeholder="请输入姓名" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input placeholder="请输入手机号" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item class="yd-btn-group">
                <el-button size="small" type="primary" :disabled="true">提交</el-button>
                <el-button size="small" :disabled="true">重置</el-button>
            </el-form-item>
        </el-form>
        <p v-if="newsData.newsContentSource" class="yd-module-label">
            <span>{{newsData.newsContentSource}}</span>
            <span v-if="newsData.newsContentUpdateTime">{{newsData.newsContentUpdateTime}}</span>
            <span v-else>{{getCurrentTime()}}</span>
        </p>
    </div>
</template>
<script>
export default {
    props: ["newsData"],
    methods: {
        newsClick(url) {
            this.$emit('newsClick', url);
        },
        //获取当前时间，格式为："2017-5-12 17:59:12"
        getCurrentTime() {
            return new Date().toLocaleString();
        }
    }
}
</script>
<style lang="less">
/*线索收集*/
.yd-news-xiansuo {
    margin-top: 10px;
    cursor: pointer;
    .yd-title {
        text-align: left;
        font-size: 14px;
        margin-bottom: 10px;
    }
    .yd-module-label {
        text-align: left;
        color: #8492A6;
        font-size: 12px;
        span {
            padding-right: 10px;
        }
    }
    >img {
        width: 100%;
        height: auto;
    }
    .el-form {
        width: 100%;
        .el-form-item {
            margin-bottom: 0;
        }
        .yd-btn-group {
            text-align: center;
        }
        .el-form-item__content {
            margin-top: 10px;
        }
    }
}
</style>




// WEBPACK FOOTER //
// CollectNews.vue?4f77f502